import { Box, Fade, FormHelperText, MenuItem, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import { RoadsideTextField } from "components/FormElements/FormElements.styled";

export const SalutationField: React.FC<{
    primarySalutations: string[];
    otherSalutations: string[];
    name: string;
    value?: string;
    onChange?: (value: ChangeEvent) => void;
    error?: boolean;
    helperText?: React.ReactNode;
}> = ({ primarySalutations, otherSalutations, name, value, onChange, error, helperText }) => {
    const isPrimary = primarySalutations.some((v) => v === value);
    const isOther = otherSalutations.some((v) => v === value);
    const [primarySelected, setPrimarySelected] = useState(isPrimary ? value : isOther ? "__other" : "");
    const [otherSelected, setOtherSelected] = useState(isOther ? value : "");
    const currentValue = (primarySelected === "__other" ? otherSelected : primarySelected) || "";

    useEffect(() => {
        if (!onChange) {
            return;
        }
        const evt = {
            target: { name: name, value: currentValue },
        };
        // @ts-ignore
        onChange(evt!);
    }, [name, currentValue, onChange]);

    return (
        <Box sx={{ mb: 3 }}>
            <Stack direction={"column"} spacing={0}>
                <RoadsideTextField
                    name={name}
                    select
                    fullWidth
                    value={currentValue}
                    onChange={onChange}
                    error={error}
                    sx={{ display: "none" }}
                >
                    {[...primarySalutations, ...otherSalutations].map((option) => (
                        <MenuItem key={`hs_${option}`} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </RoadsideTextField>
                <ToggleButtonGroup
                    exclusive
                    color={error ? "error" : "primary"}
                    value={primarySelected}
                    onChange={(_, v) => {
                        setPrimarySelected(v);
                    }}
                    sx={{ width: "100%", justifyContent: "space-between" }}
                >
                    {primarySalutations.map((p) => (
                        <ToggleButton
                            key={`salutation_${p}`}
                            value={p}
                            sx={{
                                width: 1 / (primarySalutations.length + 1),
                                borderColor: error ? "error.main" : "offGrey",
                                borderWidth: "2px",
                            }}
                        >
                            {p}
                        </ToggleButton>
                    ))}
                    <ToggleButton
                        value={"__other"}
                        sx={{
                            width: 1 / (primarySalutations.length + 1),
                            borderColor: error ? "error.main" : "offGrey",
                            borderWidth: "2px",
                        }}
                    >
                        Other
                    </ToggleButton>
                </ToggleButtonGroup>
                <Fade in={primarySelected === "__other"} unmountOnExit>
                    <div>
                        <Box
                            sx={{
                                borderWidth: 0,
                                borderColor: error ? "error.main" : "offGrey",
                                borderStyle: "solid",
                                borderLeftWidth: 2,
                                borderRightWidth: 2,
                                height: 8,
                                ml: 1,
                                mr: 1,
                                backgroundColor: error ? "error.50" : "primary.50",
                            }}
                        >
                            &nbsp;
                        </Box>
                        <RoadsideTextField
                            fullWidth
                            value={otherSelected || ""}
                            onChange={(e) => {
                                setOtherSelected(e.target.value);
                            }}
                            select
                            SelectProps={{
                                displayEmpty: true,
                                renderValue: (v: any) => v || "Select...",
                            }}
                            sx={{ mb: 0 }}
                            error={error}
                        >
                            {otherSalutations.map((option) => (
                                <MenuItem key={`salutation_${option}`} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </RoadsideTextField>
                    </div>
                </Fade>
                <FormHelperText error={error} sx={{ fontSize: 12, m: 0 }}>
                    {helperText}
                </FormHelperText>
            </Stack>
        </Box>
    );
};
